import { render, staticRenderFns } from "./PhoneSelected.vue?vue&type=template&id=58e0a54e&scoped=true"
import script from "./PhoneSelected.vue?vue&type=script&lang=js"
export * from "./PhoneSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e0a54e",
  null
  
)

export default component.exports